import { gql } from 'graphql-request';

export const listCoaDocumentsGql = gql`
  query listCoaDocuments {
    listCoaDocuments {
      ndc
      lotNumber
      fileKey
      fileName
      publicUrl
      sizeBytes
      uploadedAt
      drugName
      strength
      manufacturer
    }
  }
`;

export const listCoaEligibleLotsGql = gql`
  query listCoaEligibleLots {
    listCoaEligibleLots {
      ndc
      lotNumber
      drugName
      strength
      manufacturer
      hasCoa
    }
  }
`;

export const createCoaUploadUrlGql = gql`
  mutation createCoaUploadUrl($input: CreateCoaUploadUrlInput!) {
    createCoaUploadUrl(input: $input) {
      uploadUrl
      fileKey
      fileName
      publicUrl
      expiresAt
      overwrites
    }
  }
`;
